module.exports = __webpack_public_path__ + "img/Top_Bar-03.e38976c4.svg";